import React from 'react'
import OneDrivePage from '../../../../../../components/Onedrive/OneDrive'

const ExternalOneDrive = () => {
  return <OneDrivePage type="external" dokumentationPath="/integrations/other/onedrive-operational" />
}

export default ExternalOneDrive
